module.exports = __webpack_public_path__ + "img/43_18.dce41d8f.png";